// errors-handler.ts
import { ErrorHandler, Injectable, Injector} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { HttpHeaders } from '@angular/common/http';
import { UserService } from './user.service';
import { environment } from 'environments/environment';

@Injectable()
export class ErrorsHandler implements ErrorHandler {

  constructor(
     private injector: Injector,
  ) { }

  handleError(error: Error | HttpErrorResponse) {

     //const notificationService = this.injector.get(NotificationService);
     const router = this.injector.get(Router);
     const logger = this.injector.get(NGXLogger);
     const userService = this.injector.get(UserService);

      if (error instanceof HttpErrorResponse) {
        // Server or connection error happened
        if (!navigator.onLine) {
          // Handle offline error
          console.log('No Internet Connection')
          //return notificationService.notify('No Internet Connection');
        } else {
          console.log(error)
          // Handle Http Error (error.status === 403, 404...)
          //return notificationService.notify(`${error.status} - ${error.message}`);
        }
     } else {

       const dt = new Date();
       const utcDate = dt.toString();
       const env = environment.production;

       if(env)
        userService.logError({message:error.stack,level:'Error',timestamp:utcDate});

       // log the error anyway
       logger.error(error)
     }

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/errors-handler.ts